var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryEr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_8052)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_8052",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_8052)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 0V10H0V0H28Z",
    fill: "#29C53F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 10V20.6667H0V10H28Z",
    fill: "#579DED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20L28 10L0 0V20Z",
    fill: "#F42D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 10C12.6667 12.2092 10.8758 14 8.66667 14C6.45753 14 4.66667 12.2092 4.66667 10C4.66667 7.7909 6.45753 6.00004 8.66667 6.00004C10.8758 6.00004 12.6667 7.7909 12.6667 10Z",
    stroke: "#FFC63C",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 9.33333C8.36811 9.33333 8.66659 9.03486 8.66659 8.66667C8.66659 8.29848 8.36811 8 7.99992 8C7.63173 8 7.33325 8.29848 7.33325 8.66667C7.33325 9.03486 7.63173 9.33333 7.99992 9.33333Z",
    fill: "#FFC63C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33341 9.99996C9.7016 9.99996 10.0001 9.70148 10.0001 9.33329C10.0001 8.9651 9.7016 8.66663 9.33341 8.66663C8.96522 8.66663 8.66675 8.9651 8.66675 9.33329C8.66675 9.70148 8.96522 9.99996 9.33341 9.99996Z",
    fill: "#FFC63C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66667 8.66671C9.03486 8.66671 9.33333 8.36823 9.33333 8.00004C9.33333 7.63185 9.03486 7.33337 8.66667 7.33337C8.29848 7.33337 8 7.63185 8 8.00004C8 8.36823 8.29848 8.66671 8.66667 8.66671Z",
    fill: "#FFC63C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 10.6667C8.36811 10.6667 8.66659 10.3682 8.66659 10C8.66659 9.63185 8.36811 9.33337 7.99992 9.33337C7.63173 9.33337 7.33325 9.63185 7.33325 10C7.33325 10.3682 7.63173 10.6667 7.99992 10.6667Z",
    fill: "#FFC63C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33341 11.3333C9.7016 11.3333 10.0001 11.0349 10.0001 10.6667C10.0001 10.2985 9.7016 10 9.33341 10C8.96522 10 8.66675 10.2985 8.66675 10.6667C8.66675 11.0349 8.96522 11.3333 9.33341 11.3333Z",
    fill: "#FFC63C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 12C8.36811 12 8.66659 11.7015 8.66659 11.3333C8.66659 10.9651 8.36811 10.6666 7.99992 10.6666C7.63173 10.6666 7.33325 10.9651 7.33325 11.3333C7.33325 11.7015 7.63173 12 7.99992 12Z",
    fill: "#FFC63C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33341 12.6667C9.7016 12.6667 10.0001 12.3682 10.0001 12C10.0001 11.6319 9.7016 11.3334 9.33341 11.3334C8.96522 11.3334 8.66675 11.6319 8.66675 12C8.66675 12.3682 8.96522 12.6667 9.33341 12.6667Z",
    fill: "#FFC63C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_8052"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryEr);
export default __webpack_public_path__ + "static/media/Country=ER.5d7508ad057e0c1e7145d2ee3e52f14c.svg";
export { ForwardRef as ReactComponent };